<lms-breadcrumb></lms-breadcrumb>
<lms-toolbar [options]="{ list: { listId: listId, hidePrint: true, hideSearch: true } }"> </lms-toolbar>

<lms-list
  [serviceProvider]="rankingService"
  (collectionUpdated)="setCollection($event)"
  [listId]="listId"
  [options]="listOptions"
>
  <div class="table-heading">
    <lms-list-header
      [listId]="listId"
      [disableSort]="true"
      class="table-item hide-on-med-and-down"
      field="rank"
      label="ranking.header.rank"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      [disableSort]="true"
      class="table-item"
      field="name"
      label="ranking.header.name"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      [disableSort]="true"
      class="table-item"
      field="surname"
      label="ranking.header.surname"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      [disableSort]="true"
      class="table-item"
      field="completedCoursesCount"
      label="ranking.header.completedCoursesCount"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      [disableSort]="true"
      class="table-item"
      field="totalMedalsCount"
      label="ranking.header.totalMedalsCount"
    ></lms-list-header>
    <lms-list-header
      [listId]="listId"
      [disableSort]="true"
      class="table-item"
      field="score"
      label="ranking.header.score"
    ></lms-list-header>
  </div>

  <lms-ranking-list-row *ngFor="let item of ranking" [item]="item"> </lms-ranking-list-row>
</lms-list>
